'use client';

import { useStoreProductsModalStore } from '@/stores/storeProductsModal/useStoreProductsModalStore';

import StoreProductsModal from './index';

const StoreProductsModalHost = () => {
    const { isOpen, storeUuid, storeName, excludedProductUuid, close } = useStoreProductsModalStore((state) => state);

    return <StoreProductsModal open={isOpen} storeUuid={storeUuid} storeName={storeName} excludedProductUuid={excludedProductUuid} onClose={close} />;
};

export default StoreProductsModalHost;
